import { useTranslations } from 'next-intl'
import { cx } from 'class-variance-authority'
import { Select } from '@skop-app/lib-front'
import { userRoles } from '@skop-app/lib-domain/constants'

import { useSelectedTeammates } from '@/hooks/useSelectedTeammates'
import type { OrderModalValues } from '@/types'

export const ResponsableSelect = ({
  order,
  setOrderValues,
  isLoading,
  className,
}: {
  order: OrderModalValues
  setOrderValues: React.Dispatch<React.SetStateAction<OrderModalValues>>
  isLoading: boolean
  className?: string
}) => {
  const t = useTranslations()
  const { data: teammates = [] } = useSelectedTeammates()

  const teammatesWithoutGuest = (teammates ?? [])
    .filter((teammate) => teammate.role !== 'GUEST')
    .map((teammate) => {
      const roleLabel = userRoles.find(
        (role) => role.value === teammate.role,
      )?.label
      return {
        label: roleLabel ? `${teammate.label} (${roleLabel})` : teammate.label,
        value: teammate.value,
      }
    })

  const manager = teammatesWithoutGuest.find(
    (teammate) => teammate.value === order.managerID,
  )

  if (!manager) return null

  return (
    <div className={cx('mt-1.5 flex flex-col gap-1.5', className)}>
      <label
        htmlFor="managerID"
        className="text-sm font-semibold text-gray-900"
      >
        {t('Order.managerDescription')}
      </label>
      <Select
        id="managerID"
        key="managerID"
        className="max-w-md p-0.5"
        placeholder={t('Order.selectManager')}
        isDisabled={isLoading}
        value={
          manager
            ? {
                label: manager?.label,
                value: order.managerID,
              }
            : null
        }
        onChange={(manager: { label: string; value: string } | null) =>
          setOrderValues({
            ...order,
            managerID: manager?.value ?? undefined,
          })
        }
        options={teammatesWithoutGuest}
        overflow
      />
    </div>
  )
}
